export default __webpack_public_path__ + "src/assets/images/landing/img_bg_2_8-2wFC.jpg";